import { NgModule, inject, provideAppInitializer } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { AppComponent } from "./app.component";
import {
    SharedConfigService,
    SharedStartupService,
    SharedUtilLogexFrameworkRootModule
} from "@mrdm-self-service-frontend/shared/util-logex-framework-setup";
import {
    LgApplicationModule,
    LgMatTrackingService,
    LG_APP_INFO,
    LG_MATOMO_CONFIGURATION
} from "@logex/framework/lg-application";
import { MatomoConfiguration } from "@mrdm-self-service-frontend/shared/util-tracking";
import { LG_APPLICATION_MULTI_EVENT_TRACERS } from "@logex/framework/core";
import { AppRoutingModule } from "./app-routing.module";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { SharedUtilAuthorizationModule } from "@mrdm-self-service-frontend/shared/util-authorization";
import { LgLocalizationModule } from "@logex/framework/lg-localization";
import { SharedModule } from "./shared/shared.module";

@NgModule({
    declarations: [AppComponent],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        LgApplicationModule,
        LgLocalizationModule,
        SharedUtilLogexFrameworkRootModule,
        SharedUtilAuthorizationModule.forRoot(),
        SharedModule,
        AppRoutingModule
    ],
    providers: [
        provideAppInitializer(() => {
        const initializerFn = ((startup: SharedStartupService) => startup.initialize())(inject(SharedStartupService));
        return initializerFn();
      }),
        {
            provide: LG_APP_INFO,
            useFactory: (configService: SharedConfigService) => {
                const config = configService.getConfiguration();
                return {
                    environment: config?.environment,
                    fullAppName: "",
                    productId: "",
                    toolInstanceName: config?.instance,
                    versionNumber: config?.version,
                    overrideCurrencyPrefix: "",
                    overrideCurrencySuffix: "",
                    doNotDoGaTracking: () => false,
                    isProduction: () => config?.environment === "prod"
                };
            },
            deps: [SharedConfigService]
        },
        {
            provide: LG_MATOMO_CONFIGURATION,
            useExisting: MatomoConfiguration
        },
        {
            provide: LG_APPLICATION_MULTI_EVENT_TRACERS,
            useExisting: LgMatTrackingService,
            multi: true
        },
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class AppModule {}
